import { MAPBOX_TOKEN } from './mapConfig';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const permissionState = async () => {
  try {
    return (await navigator.permissions.query({ name: 'geolocation' })).state;
  } catch (e) {
    return 'unknown';
  }
};

// Una sola posizione, null se negata, spenta o senza fix. Solo Avvia può mostrare la richiesta del browser.
export const getFix = async (timeoutMs, allowPrompt = false) => {
  if (!navigator.geolocation) return null;
  const state = await permissionState();
  if (state === 'denied' || (state === 'prompt' && !allowPrompt)) return null;
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), timeoutMs + 500);
    navigator.geolocation.getCurrentPosition(
      (pos) => { clearTimeout(timer); resolve(pos.coords); },
      () => { clearTimeout(timer); resolve(null); },
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 30000 }
    );
  });
};

const familyHeaders = (token) => ({ 'Content-Type': 'application/json', 'X-Family-Token': token });

export const recordWalkPoint = async ({ sessionId, token, kind, timeoutMs, allowPrompt = false }) => {
  const coords = await getFix(timeoutMs, allowPrompt);
  if (!coords) return false;
  try {
    const res = await fetch(`${API_URL}/api/gps/point`, {
      method: 'POST',
      headers: familyHeaders(token),
      body: JSON.stringify({
        session_id: sessionId, kind, latitude: coords.latitude, longitude: coords.longitude, accuracy: coords.accuracy
      })
    });
    return res.ok && Boolean((await res.json()).recorded);
  } catch (e) {
    return false;
  }
};

export const fetchWalkMap = async (sessionId, token) => {
  try {
    const res = await fetch(`${API_URL}/api/gps/walk/${sessionId}`, { headers: familyHeaders(token) });
    return res.ok ? await res.json() : null;
  } catch (e) {
    return null;
  }
};

const reverseGeocode = async ({ lat, lng }) => {
  try {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?types=poi,address&language=it&limit=1&access_token=${MAPBOX_TOKEN}`;
    const res = await fetch(url);
    if (!res.ok) return null;
    return (await res.json()).features?.[0]?.text || null;
  } catch (e) {
    return null;
  }
};

// Nomi di partenza e rientro: risolti una sola volta e salvati con la passeggiata. Restituisce pin aggiornati o null.
export const resolveWalkPlaces = async ({ sessionId, token, pins }) => {
  const start = pins.find((p) => p.label === 'Partenza' && !p.place);
  const end = pins.find((p) => p.label === 'Rientro' && !p.place);
  if (!start && !end) return null;
  const [startPlace, endPlace] = await Promise.all([start && reverseGeocode(start), end && reverseGeocode(end)]);
  if (!startPlace && !endPlace) return null;
  try {
    const res = await fetch(`${API_URL}/api/gps/places`, {
      method: 'POST',
      headers: familyHeaders(token),
      body: JSON.stringify({ session_id: sessionId, start_place: startPlace || null, end_place: endPlace || null })
    });
    return res.ok ? await res.json() : null;
  } catch (e) {
    return null;
  }
};
